// Data Perusahaan (/data-perusahaan, feature company_data, every user-app
// role; optional for the user). Pluto reads the company's dokumen
// persyaratan when it drafts a document, and a company group shares them.
//   dp_header   plain spacing   h1 and what the page is for
//   dp_docs     card            Dokumen perusahaan (../company/CompanyDocuments.tsx)
//   dp_group    card            Grup perusahaan (../company/CompanyGroup.tsx)
// A change of group (made, joined, left, deleted) reloads the documents too:
// which documents an account reads follows its current group.
import { useRef, useState } from "react";
import * as API from "../api";
import type { CompanyDocument, CompanyGroup } from "../api";
import { useAuth } from "../auth";
import { CompanyDocuments } from "../company/CompanyDocuments";
import { CompanyGroupSection } from "../company/CompanyGroup";
import { PageHeader, useAsync, useTitle } from "../ui/components";

export function DataPerusahaanScreen() {
  useTitle("Data Perusahaan");
  const { state } = useAuth();
  const meId = state.status === "authed" ? state.user.id : "";
  const [version, setVersion] = useState(0);
  const group = useAsync<CompanyGroup | null>(() => API.getMyCompanyGroup(), [version]);
  const docs = useAsync<CompanyDocument[]>(() => API.getCompanyDocuments(), [version]);

  // "No group" is a null answer too: after the first answer a reload keeps
  // the section (and the message it shows) instead of a skeleton.
  const groupLoaded = useRef(false);
  if (!group.loading && !group.error) groupLoaded.current = true;

  const reloadAll = () => setVersion((v) => v + 1);
  const onGroup = (next: CompanyGroup | null) => {
    const changed = (group.data?.id ?? null) !== (next?.id ?? null);
    group.set(next);
    if (changed) docs.reload();
  };
  const replace = (doc: CompanyDocument) => docs.set((docs.data ?? []).map((d) => (d.id === doc.id ? doc : d)));

  return (
    <div className="region">
      <PageHeader
        divided
        title="Data Perusahaan"
        lead="Pluto memakai dokumen persyaratan perusahaan (NIB, akta, SBU, pengalaman, CV tenaga ahli) untuk mengisi dokumen yang dibuat, dan berbagi pengetahuan dengan anggota grup."
      />
      <CompanyDocuments group={group.data} documents={docs.data} loading={docs.loading} error={docs.error} reload={docs.reload} replace={replace} reloadAll={reloadAll} />
      <CompanyGroupSection group={group.data} loading={group.loading && !groupLoaded.current} error={group.error} onGroup={onGroup} reloadAll={reloadAll} meId={meId} />
    </div>
  );
}
